import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { MdKeyboardArrowDown } from 'react-icons/md'
import styles from './tagSelect.module.scss'

const TagSelect = (props) => {
  const { placeholder, value, options, onChange } = props

  const handleChange = (e) => {
    onChange(e.target.value)
  }

  const isEmpty = !value || value.length === 0

  const classesContainer = classNames(styles.container, {
    [styles.active]: !isEmpty
  })

  return (
    <div className={classesContainer}>
      <select onChange={handleChange} value={value}>
        <option value={0}>{placeholder}</option>
        {options.map((item) => (
          <option key={item.value} value={item.value}>
            {item.name}
          </option>
        ))}
      </select>
      <MdKeyboardArrowDown color={!isEmpty ? '#fff' : '#737373'} />
    </div>
  )
}

TagSelect.defaultProps = {
  placeholder: 'Selecione',
  value: 0,
  options: [],
  onChange: () => {}
}

TagSelect.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array
  ]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string
    })
  ),
  onChange: PropTypes.func
}

export default TagSelect
